import {
    IAPIOccupancyRateReport,
    IOccupancyRateReport,
} from './IOccupancyRateReport'

class Transformer {
    static transform(report: IAPIOccupancyRateReport): IOccupancyRateReport[] {
        const results: { [personUUid: string]: IOccupancyRateReport } = {}
        for (const dateKey in report) {
            if (!report.hasOwnProperty(dateKey)) {
                continue
            }
            for (const personUuid in report[dateKey]) {
                if (!report[dateKey].hasOwnProperty(personUuid)) {
                    continue
                }

                if (!results[personUuid]) {
                    results[personUuid] = {
                        personUuid,
                        workingMinutes: 0,
                        appointmentMinutes: 0,
                        blockedMinutes: 0,
                    }
                }

                results[personUuid].workingMinutes +=
                    report[dateKey][personUuid].working_minutes
                results[personUuid].appointmentMinutes +=
                    report[dateKey][personUuid].appointment_minutes
                results[personUuid].blockedMinutes +=
                    report[dateKey][personUuid].blocked_minutes
            }
        }

        return Object.values(results)
    }
}

export default Transformer
